import { z } from 'zod';

const objectIdString = z.string().regex(/^[0-9a-fA-F]{24}$/, 'form.validation.invalidId');

/** API create body */
export const CreateRootCauseSchema = z
    .object({
        name: z.string().trim().min(1),
        description: z.string().optional(),
        scopeType: z.enum(['tenant', 'units']).default('tenant'),
        scopeUnitIds: z.array(objectIdString).optional(),
        customFields: z.record(z.unknown()).optional(),
    })
    .superRefine((data, ctx) => {
        if (data.scopeType === 'units' && (!data.scopeUnitIds || data.scopeUnitIds.length === 0)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'form.validation.scopeUnitsRequired',
                path: ['scopeUnitIds'],
            });
        }
    })
    .transform((data) => ({
        ...data,
        scopeUnitIds: data.scopeType === 'tenant' ? [] : (data.scopeUnitIds || []),
    }));

/** API update body (all fields optional) */
export const UpdateRootCauseSchema = z
    .object({
        name: z.string().trim().min(1).optional(),
        description: z.string().optional(),
        scopeType: z.enum(['tenant', 'units']).optional(),
        scopeUnitIds: z.array(objectIdString).optional(),
        customFields: z.record(z.unknown()).optional(),
    })
    .superRefine((data, ctx) => {
        if (data.scopeType === 'units' && (!data.scopeUnitIds || data.scopeUnitIds.length === 0)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'form.validation.scopeUnitsRequired',
                path: ['scopeUnitIds'],
            });
        }
    })
    .transform((data) => {
        if (data.scopeType === undefined) return data;
        return {
            ...data,
            scopeUnitIds: data.scopeType === 'tenant' ? [] : (data.scopeUnitIds || []),
        };
    });

/**
 * Payload validated in SDK before create/update (matches API body shape).
 */
export const RootCauseFormSchema = z
    .object({
        name: z.string().min(1, 'form.validation.rootCauseNameRequired'),
        description: z.string().optional(),
        scopeType: z.enum(['tenant', 'units']).default('tenant'),
        scopeUnitIds: z.array(objectIdString).optional(),
    })
    .superRefine((data, ctx) => {
        if (data.scopeType === 'units' && (!data.scopeUnitIds || data.scopeUnitIds.length === 0)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'form.validation.scopeUnitsRequired',
                path: ['scopeUnitIds'],
            });
        }
    });

export const BatchRootCauseScopeSchema = z
    .object({
        ids: z.array(objectIdString).min(1),
        scopeType: z.enum(['tenant', 'units']),
        scopeUnitIds: z.array(objectIdString).optional(),
    })
    .superRefine((data, ctx) => {
        if (data.scopeType === 'units' && (!data.scopeUnitIds || data.scopeUnitIds.length === 0)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'form.validation.scopeUnitsRequired',
                path: ['scopeUnitIds'],
            });
        }
    });
